<div class="currency-wallet" #currencyWalletWrapper>
  <div class="expansion-row">
    <div class="contants-row onact96" (click)="handleOpen()" [class.diasbled]="isDiasbled">
      <!--用户金额-->
      <ng-container *ngIf="!defaultCurrencyLoading">
        <div class="amount">
          <ng-container *ngIf="currentCurrencyData">
            <img class="currency-icon" [src]="currentCurrencyData.icon" />
            @if (isShowPlaying) {
              <span class="play-in">{{ 'in_play' | translate }}</span>
            } @else {
              <span #amount>
                {{
                  currencyWalletService.balanceFormat(
                    allCurrencyBalance
                      | filterByKeyValue: 'currency' : currentCurrencyData.currency : 'nonStickyBalance',
                    currentCurrencyData.currency,
                    { hasCurrency: displayInFiat }
                  )
                }}
              </span>
            }
          </ng-container>
        </div>
        <i class="select-icon fi-cheveron-down" [class.active]="supportExpanded"></i>
      </ng-container>
      <i class="animation-icon-loading-dot" *ngIf="defaultCurrencyLoading"><i></i><i></i><i></i></i>
    </div>
    <div class="toggle mutual-opacity onact96" [class.disabled]="renderPiqCheckedLoading()" (click)="toWalletPage()">
      <i class="fi-plus-chunky"></i>
    </div>
  </div>
</div>

<!--币种切换tab-->
<ng-template #currencySettingsDialog>
  <div class="currency-settings-dialog" @expansion>
    @if (layoutService.isH5$ | async) {
      <div class="expansion-title">
        {{ 'select_currency' | translate }}

        <cs-icon-button
          [iconType]="'icon'"
          [icon]="'fi-x'"
          [frameShape]="'square'"
          [color]="'secondary'"
          [size]="'24'"
          [iconFontSize]="'12'"
          (buttonClick)="supportExpanded = false"
        ></cs-icon-button>
      </div>
    }

    <div class="expansion-header">
      <cs-input
        [prefixIconName]="'fi-search'"
        [placeholder]="('search_currency' | translate) || ('search' | translate)"
        [maxLength]="40"
        [(value)]="searchKeyWord"
        [marginBottom]="'0'"
      />
      <div class="tabs">
        <div
          class="tab offset-right onact96-not"
          [class.active]="walletCurrencyView === 'crypto'"
          (click)="setWalletCurrencyView('crypto')"
        >
          {{ 'crypto' | translate }}
        </div>
        <div
          class="tab onact96-not"
          [class.active]="walletCurrencyView === 'cash'"
          (click)="setWalletCurrencyView('cash')"
        >
          {{ 'tab_cash' | translate }}
        </div>
      </div>
    </div>

    <div class="expansion-body">
      @if (walletCurrencyView === 'cash') {
        @if (displayedWalletCurrencies.length === 0) {
          <app-empty
            [style.padding]="'var(--lg) var(--md)'"
            [title]="'your_wallet_is_empty' | translate"
            [message]="'have_not_added_any_funds' | translate"
          ></app-empty>
        } @else {
          @for (item of displayedWalletCurrencies; track item.currency) {
            <cs-standard-tab
              [ngClass]="{
                onact96: true,
              }"
              (click)="$event.stopPropagation(); handleSelect(item)"
            >
              <div class="rate-clounm">
                <img [src]="item.icon" />
                <span>{{ item.currency }}</span>
              </div>

              <div class="amount-value">
                @if (displayInFiat) {
                  {{
                    currencyWalletService.amountAfterCalculateRate(item.nonStickyBalance || 0, item.currency)
                      | currencyValue: inFiatConvertType
                  }}
                  {{ inFiatConvertType }}
                } @else {
                  {{ item.symbol || '' }}{{ item.nonStickyBalance || 0 | currencyValue: item.currency }}
                }
              </div>
            </cs-standard-tab>
          }
        }
      } @else {
        @if (
          (checkZeroCurrencies | filterByText: searchKeyWord : ['currency'] | filterByKeyValue: 'isDigital' : true)
            .length === 0
        ) {
          <app-empty
            [style.padding]="'var(--lg) var(--md)'"
            [title]="'your_wallet_is_empty' | translate"
            [message]="'have_not_added_any_funds' | translate"
          ></app-empty>
        } @else {
          @for (
            item of checkZeroCurrencies
              | filterByText: searchKeyWord : ['currency']
              | filterByKeyValue: 'isDigital' : true;
            track $index
          ) {
            <cs-standard-tab
              [ngClass]="{
                onact96: true,
                'grid-layout':
                  allCurrencyBalance
                  | filterByText: searchKeyWord : ['currency']
                  | filterByKeyValue: 'currency' : item.currency : 'isShowNonSticky',
              }"
              (click)="$event.stopPropagation(); handleSelect(item)"
            >
              <div class="rate-clounm">
                <img [src]="item.icon" />
                <span>{{ item.currency }}</span>
              </div>

              <div class="amount-value">
                @if (displayInFiat && item.isDigital) {
                  {{
                    currencyWalletService.amountAfterCalculateRate(
                      allCurrencyBalance
                        | filterByText: searchKeyWord : ['currency']
                        | filterByKeyValue: 'currency' : item.currency : 'nonStickyBalance',
                      item.currency
                    ) | currencyValue: inFiatConvertType
                  }}
                  {{ inFiatConvertType }}
                } @else {
                  {{
                    (item.isDigital
                      ? ''
                      : (currencies
                          | filterByText: searchKeyWord : ['currency']
                          | filterByKeyValue: 'currency' : item.currency : 'symbol') || '') +
                      (allCurrencyBalance
                        | filterByText: searchKeyWord : ['currency']
                        | filterByKeyValue: 'currency' : item.currency : 'nonStickyBalance'
                        | currencyValue: item.currency)
                  }}
                }
              </div>
            </cs-standard-tab>
          }
        }
      }
    </div>

    <div class="expansion-footer">
      <div class="wallet-summary">
        <div class="wallet-summary-row">
          <div class="wallet-summary-label">{{ 'bonus' | translate }}</div>
          <div class="wallet-summary-value">
            <app-assets-value
              [value]="lockBonus"
              [currentCurrency]="currentCurrencyData.currency || 'USDT'"
              [currentCurrencyIcon]="currentCurrencyData.icon || ''"
              [displayInFiat]="displayInFiat"
            />
          </div>
        </div>

        <div class="wallet-summary-row">
          <div class="wallet-summary-label">{{ 'total_balance' | translate }}</div>
          <div class="wallet-summary-value">
            <app-assets-value
              [value]="totalAsset"
              [currentCurrency]="currentCurrencyData.currency || 'USDT'"
              [currentCurrencyIcon]="currentCurrencyData.icon || ''"
              [displayInFiat]="displayInFiat"
            />
          </div>
        </div>
      </div>

      <div class="wallet-settings">
        <app-fiat-display-switch (fiatSelectionBtnClick)="supportExpanded = false" />
        <cs-switch
          [label]="'hide_zero_balances' | translate"
          [(ngModel)]="hideZero"
          (ngModelChange)="currencyWalletService.hideZero$.next($event)"
        />
      </div>
    </div>
  </div>
</ng-template>
